import classNames from "classnames";
import React, { useRef } from "react";
import { useContainerQuery } from "react-container-query";
import { query } from "../../../shared/styled/Theme";
import { dateRangeTypes, useMatchList } from "../../utils";
import { MatchListHeader } from "../MatchListHeader/MatchListHeader";
import { MatchWrapper } from "../MatchWrapper/MatchWrapper";
import {
  StyledMatchGroup,
  StyledMatchListWrapper,
  StyledMatchHeaderWrapper,
} from "./StyledMatchListWrapper";
import dayjs from "dayjs";
import useMatchListScroll from "./useMatchListScroll";

export const MatchListWrapper = ({
  d3Matches = null,
  showSecondaryTeams = false,
  hideMatchPromos = false,
  showClubRanks = false,
  showCompetitionStage = false,
  showRoundDetail = false,
  showGroupInformation = false,
  weekRange = null,
  matchList = null,
  dateRangeType = null,
}) => {
  const [params, containerRef] = useContainerQuery(query);
  const matchPosition = useRef(0);
  const formattedMatchList = useMatchList({
    matchList,
    dateRangeType,
    weekRange,
  });
  const focusRef = React.useRef(null);

  const isYearly = dateRangeType === dateRangeTypes.year;

  useMatchListScroll(focusRef, isYearly);

  if (formattedMatchList == null) {
    return null;
  }

  const isSameMonth = (date) => {
    return dayjs().isSame(date, "month");
  };

  return (
    <StyledMatchListWrapper className={classNames(params)} ref={containerRef}>
      {formattedMatchList.map((matchGroup, i) => {
        const isCurrentMonth = isSameMonth(matchGroup.date);

        return (
          <StyledMatchGroup key={`${matchGroup.date}-${i}`}>
            <StyledMatchHeaderWrapper
              ref={isCurrentMonth && isYearly ? focusRef : null}
            >
              <MatchListHeader
                matchDate={matchGroup.date}
                dateRangeType={dateRangeType}
              />
            </StyledMatchHeaderWrapper>
            {matchGroup.matches &&
              matchGroup.matches.length > 0 &&
              matchGroup.matches.map((match, j) => {
                const d3Match = d3Matches?.get(match?.match_id) || {};

                if (i === 0 && j === 0) matchPosition.current = 0;
                matchPosition.current++;

                return (
                  <MatchWrapper
                    d3Match={d3Match}
                    statsAPIMatch={match}
                    key={match?.match_id}
                    showClubRanks={showClubRanks}
                    showCompetitionStage={showCompetitionStage}
                    showRoundDetail={showRoundDetail}
                    showGroupInformation={showGroupInformation}
                    showSecondaryTeams={showSecondaryTeams}
                    hideMatchPromos={hideMatchPromos}
                    position={matchPosition?.current}
                  />
                );
              })}
          </StyledMatchGroup>
        );
      })}
    </StyledMatchListWrapper>
  );
};
